module.exports = __webpack_public_path__ + "media/Components/fonts/Graduate-990f390ba484ddf3d5e0edcb2bee5201.ttf";